import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import ReviewCommission from './modal';

@modal(
  {
    className: 'review-commission-modal-container',
  },
  true,
)
class ReviewCommissionContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, commissionTier, properties, onConfirm, action } = this.props;

    return (
      <div className="review-commission-modal">
        <div className="review-commission-modal__header">
          {t(`cms.property.commission.create.create_commission_modal.delete.title`)}
          <CloseOutlined
            className="review-commission-modal__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>

        <ReviewCommission
          commissionTier={commissionTier}
          properties={properties}
          onClose={this.props.handleCloseModal}
          onConfirm={onConfirm}
          action={action}
        />
      </div>
    );
  }
}

ReviewCommissionContainer.propTypes = {
  t: PropTypes.func.isRequired,
  commissionTier: PropTypes.object.isRequired,
  properties: PropTypes.array.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
};

ReviewCommissionContainer.defaultProps = {
  t: () => {},
  commissionTier: {},
  properties: [],
  handleCloseModal: () => {},
  onConfirm: () => {},
  action: '',
};

export default ReviewCommissionContainer;
